// Dependencies

import React from 'react';

import classnames from 'classnames';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import { times } from 'lodash';
import PropTypes from 'prop-types';

// Local Components
import LockingTable from '../locking-table/locking-table';

// CSS
require('./scrolling-table.less');

const ScrollingTable = (props) => {
  const { className, data } = props;

  return (
    <div className={classnames('scrolling-table', className)}>
      {times(2, (i) => (
        <div key={i}>
          <LockingTable data={data} />
        </div>
      ))}
    </div>
  );
};

ScrollingTable.displayName = 'ScrollingTable';

ScrollingTable.propTypes = {
  className: PropTypes.string,
  data: PropTypes.object.isRequired,
};

ScrollingTable.defaultProps = {
  className: null,
};

export default ScrollingTable;
